import { render, staticRenderFns } from "./outputRecord.vue?vue&type=template&id=2bcfac1b&scoped=true"
import script from "./outputRecord.vue?vue&type=script&lang=js"
export * from "./outputRecord.vue?vue&type=script&lang=js"
import style0 from "./outputRecord.vue?vue&type=style&index=0&id=2bcfac1b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bcfac1b",
  null
  
)

export default component.exports